<template>
  <el-dialog title="" :visible.sync="innerVisible" center custom-class="mini-no-dialog" width="400px" height="600px"
             :close-on-click-modal="false"
             append-to-body open>
    <div style="width:260px;height:330px;margin:0 auto;padding: 15px;background-color:#3b2699;">
      <div style="padding: 0px;margin:0px;">
        <img :src="logimg" id="logo-img"  style="height:50px;float:left;">
      </div>
      <img style="height: 250px;width:250px;margin-top:4px;" :src="imgpath"/>
      <div style="font-size:12px;text-align: center;height:20px;color: white">
        扫一扫上面的二维码图案,注册门店
      </div>
    </div>
  </el-dialog>
</template>
<script>


  export default {
    name: "ExternaldeptcontactorQRcode",
    data() {
      return {
        innerVisible: false,
        logimg: '',
        form: {},
        imgpath: "",//二维码路径
        userInfoModel: {},
      }
    },
    methods: {
      show(row) {
        this.form = row
        this.innerVisible = true
        this.imgpath = window.API_ROOT + "/set/externaldept/getqrcode?uguid=" + this.form.uguid + "&tenantid=" + this.userInfoModel.tenantid

      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      var tokenInfo = JSON.parse(localStorage.getItem("hpapi_tokenModel"));
      this.logimg = tokenInfo.logimg;
    },

    components: {},
  }
</script>

<style scoped>



</style>



// WEBPACK FOOTER //
// src/components/set/externaldept/ExternaldeptcontactorQRcode.vue